const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:6d723260-b6ba-46b1-8aba-9ade71bcf1f9",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_OaUe0gn8S",
    "aws_user_pools_web_client_id": "1g75dj0b865h4lj89443a2gd0h",
    "oauth": {
        "domain": "casadosaber-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://signin.ondemand.casadosaber.com.br/",
        "redirectSignOut": "https://signin.ondemand.casadosaber.com.br/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};

export default awsmobile;
